import Event from "./event";

export default Event;
